import React, { useState } from 'react';

const campgroundQuestions = ({ location, url }) => [
  {
    question: `How much does camping cost in ${location}?`,
    answer: `Camping rates in ${location} will vary depending on the campground and even length of stay. In general, expect to pay between $20 to $40 per night`,
  },
  {
    question: `How much does it cost to stay at an RV park in ${location}?`,
    answer:
      'Camping at an RV park costs more than a campground stay. Like campground rates,  RV campsite rates differ from park to park but generally fall between $30 & $80 per night.',
  },
  {
    question: `How long can you stay at a ${location} campground or RV park?`,
    answer:
      'The amount of time you can stay at a park or campground will vary from place to place depending on availability and restrictions. Long-term spaces are easier to snag during an off-season.',
  },
  {
    question: `Are pets allowed at RV parks and campgrounds in ${location}?`,
    answer: `Yes! Most of those mentioned above allow pets. Do keep in mind, however, that not all <a href="${url}">${location} RVs for rent</a> are pet-friendly. You can filter your RV search to show pet-friendly rigs.`,
  },
  {
    question: 'Can I get an RV delivered to my campsite?',
    answer:
      'You can! Many Outdoorsy owners offer delivery within a certain radius. Additional fees may apply based on distance and other setup/delivery options.',
  },
];

const FAQs = ({ location, url }) => {
  const [openQuestion, setOpenQuestion] = useState(false);

  const questions = campgroundQuestions({ location, url });

  return (
    <dl className="w-full" itemScope itemType="https://schema.org/FAQPage">
      {questions.map((question, index) => (
        <div
          key={(question, index)}
          className="pb-8 border-b border-gray-200"
          itemScope
          itemProp="mainEntity"
          itemType="https://schema.org/Question">
          <dt className="pb-0 mt-6 text-2xl leading-7">
            <button
              onClick={() =>
                openQuestion === index ? setOpenQuestion(false) : setOpenQuestion(index)
              }
              className="flex items-start justify-between w-full text-left text-gray-500 focus:outline-none focus:text-gray-900">
              <span className="font-medium text-gray-900" itemProp="name">
                {question.question}
              </span>
              <span
                className={`flex items-center ml-6 h-7 transform
                ${openQuestion === index ? 'rotate-180' : 'rotate-0'}`}>
                <svg className="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </button>
          </dt>
          <dd
            className={`mt-2 ${openQuestion === index ? '' : 'hidden'}`}
            itemScope
            itemProp="acceptedAnswer"
            itemType="https://schema.org/Answer">
            <p
              className="w-full text-base text-gray-900 leading-6 lg:w-2/3"
              itemProp="text"
              dangerouslySetInnerHTML={{ __html: question.answer }}
            />
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default FAQs;
